<template>
    <div v-if="val" role="presentation" class="header-modal sc-iwCbjw eZYFfY sc-kcrxFD gQYaQL MuiDialog-root sc-kcFYLC MGSIo MuiModal-root">
        <div aria-hidden="true" class="sc-dEsUz hCzjvX MuiBackdrop-root sc-jcpbFC foYXrm MuiModal-backdrop"
             style="opacity: 1; transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;"></div>
        <div tabindex="0" data-testid="sentinelStart"></div>
        <div class="sc-hLznAM bbEuoX MuiDialog-container MuiDialog-scrollPaper" role="presentation" tabindex="-1"
             style="opacity: 1; transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;">
            <div
                class="sc-ispOId kYdSNF MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation24 sc-iLBJAN dYLaNu MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm"
                role="dialog" aria-describedby="alert-dialog-description" aria-labelledby="alert-dialog-title">
                <div class="sc-fxAUDG dZeMmL MuiGrid-root MuiGrid-container">
                    <button
                        @click="val = false"
                        class="sc-crozmw bTBmEt MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textFocus.90 MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-disableElevation MuiButton-fullWidth sc-gAigJI dTHFfT MuiButton-root MuiButton-text MuiButton-textFocus.90 MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-disableElevation MuiButton-fullWidth sc-datlNk euokdM sc-jdWxax gLrtxx"
                        tabindex="0" type="button" role="button"><img
                        src="/icons/close-x.svg"
                        alt="exit-button"></button>
                </div>
                <div class="sc-fwEaKe sc-cYZqiH hQjQvj MuiBox-root">
                    <slot></slot>
                </div>
            </div>
        </div>
        <div tabindex="0" data-testid="sentinelEnd"></div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: String,
    },
    watch: {
        modelValue() {
            $('.MuiGrid-root.MuiGrid-container').toggleClass('popup_open')
        }
    },
    computed: {
        val: {
            get() {
                return this.modelValue
            },
            set(val) {
                this.$emit('update:modelValue', val)
            }
        }
    }
}
</script>
